import { getPositionDetails } from "./components";
import { getJobsData } from "./getJobsData";
import { hideLoadingIndicator, showLoadingIndicator } from "./loading";

export function getJobDescription(id) {
	showLoadingIndicator("jobDescription");

	const successHandler = (data) => {
		const positionTitle = document.querySelector("h1");
		positionTitle.innerText = data.title;

		const positionDetails = document.getElementById("positionDetails");
		positionDetails.classList.add("hero__details");
		getPositionDetails(positionDetails, data);

		const container = document.getElementById("jobDescription");
		container.innerHTML = data.description;

		const applyLinks = document.querySelectorAll("a[data-apply]");
		applyLinks.forEach((link) => {
			link.href = `${data.absoluteUrl}/new`;
		});
		hideLoadingIndicator("jobDescription");
	};

	if (id) {
		getJobsData(`/position/${id}`, {}, successHandler, () => {});
	}
}
